var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "M4.443 23.62a.5.5 0 0 0 0 .76l12.732 10.912a.5.5 0 0 0 .825-.38V27h23.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H18v-7.913a.5.5 0 0 0-.825-.38z"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDQyOSAyMy42MjA0QzQuMjEwMDkgMjMuODE5OSA0LjIxMDA5IDI0LjE4MDEgNC40NDI5IDI0LjM3OTZMMTcuMTc0NiAzNS4yOTI1QzE3LjQ5ODkgMzUuNTcwNSAxOCAzNS4zNDAxIDE4IDM0LjkxMjlMMTggMjdINDEuNUM0MS43NzYxIDI3IDQyIDI2Ljc3NjEgNDIgMjYuNVYyMS41QzQyIDIxLjIyMzkgNDEuNzc2MSAyMSA0MS41IDIxSDE4TDE4IDEzLjA4NzFDMTggMTIuNjU5OSAxNy40OTg5IDEyLjQyOTUgMTcuMTc0NiAxMi43MDc1TDQuNDQyOSAyMy42MjA0WiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";